function getJSON(str) {
  try {
    return JSON.parse(str);
  } catch (err) {
    return str;
  }
}

function setItem(key, paylod) {
  sessionStorage.setItem(key, JSON.stringify(paylod));
}

function getItem(key) {
  return getJSON(sessionStorage.getItem(key));
}

function removeItem(key) {
  sessionStorage.removeItem(key);
}

function setLocalStorage(key, paylod) {
  localStorage.setItem(key, JSON.stringify(paylod));
}

function getLocalStorage(key) {
  return getJSON(localStorage.getItem(key));
}

function removeLocalStorage(key) {
  localStorage.removeItem(key);
}

export default {
  setItem,
  getItem,
  removeItem,
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
};
